import { render, staticRenderFns } from "./crud-template.vue?vue&type=template&id=08ba56d0"
import script from "./crud-template.vue?vue&type=script&lang=js"
export * from "./crud-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports